import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createNewRoleAPI, createNewUserAPI, getAdminUserAPI, getAllAdminUserRolesAPI, getAllAdminUsersAPI } from "../api/UserManagementApi";

const initialState = {
  allusers: [],
  user: {},
  currentAdminUser: {},
  roles: [],

  createLoading: false,
  loading: false,
  currentUserLoading: false,
};

export const createNewUser = createAsyncThunk(
  "users/createNewUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createNewUserAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const createNewRole = createAsyncThunk(
  "users/createNewRole",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createNewRoleAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getAllAdminUsers = createAsyncThunk(
  "users/getAllAdminUsers",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllAdminUsersAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getAdminUser = createAsyncThunk(
  "users/getAdminUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAdminUserAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getAllAdminUserRoles = createAsyncThunk(
  "users/getAllAdminUserRoles",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllAdminUserRolesAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const getCurrentAdminUser = createAsyncThunk(
  "users/getCurrentAdminUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAdminUserAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);



const UserManagementSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    //create New User
    builder.addCase(createNewUser.pending, (state) => {
      state.createLoading = true;
    });
    builder.addCase(createNewUser.fulfilled, (state, action) => {
      // state.allusers = action?.payload?.response;
      state.createLoading = false;
    });
    builder.addCase(createNewUser.rejected, (state) => {
      state.createLoading = false;
    });

    //create New role
    builder.addCase(createNewRole.pending, (state) => {
      state.createLoading = true;
    });
    builder.addCase(createNewRole.fulfilled, (state, action) => {
      // state.allusers = action?.payload?.response;
      state.createLoading = false;
    });
    builder.addCase(createNewRole.rejected, (state) => {
      state.createLoading = false;
    });

    //get all roles
    builder.addCase(getAllAdminUsers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllAdminUsers.fulfilled, (state, action) => {
      state.allusers = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllAdminUsers.rejected, (state) => {
      state.loading = false;
    });

    //create New User
    builder.addCase(getAdminUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAdminUser.fulfilled, (state, action) => {
      state.user = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAdminUser.rejected, (state) => {
      state.loading = false;
    });

    //create New User
    builder.addCase(getAllAdminUserRoles.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllAdminUserRoles.fulfilled, (state, action) => {
      state.roles = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllAdminUserRoles.rejected, (state) => {
      state.creatloadingeLoading = false;
    });

    //get current admin User
    builder.addCase(getCurrentAdminUser.pending, (state) => {
      state.currentUserLoading = true;
    });
    builder.addCase(getCurrentAdminUser.fulfilled, (state, action) => {
      state.currentAdminUser = action?.payload?.response;
      state.currentUserLoading = false;
    });
    builder.addCase(getCurrentAdminUser.rejected, (state) => {
      state.currentUserLoading = false;
    });
  }
})

export default UserManagementSlice.reducer;